import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { Jumbotron, Button, ListGroup, ListGroupItem, Image, Pagination, Grid, Col, Row, Clearfix, Panel} from 'react-bootstrap';
//import image_data from './test_out_29_06_17.json';
import $ from 'jquery';


class ImageShow extends Component {
    constructor(props){
        super(props);
    }

    render() {
        function is_name(name){
            if(name != "id" && name != "fname") return true;
            return false;
        }
        const cur_comp = this;
        const list_items = Object.keys(this.props.im).filter(is_name).sort().map((sent_name) => {
            return (
                <ListGroupItem key={cur_comp.props.im.id+"_"+sent_name}><b>{sent_name}:</b><br/>{cur_comp.props.im[sent_name]}</ListGroupItem>
                );
        })
        const img_key = this.props.im.id + "_fname";
        return (
                <ListGroup>
                    <ListGroupItem key={img_key}><Image src={this.props.im.fname} responsive/></ListGroupItem>
                    {list_items}
                </ListGroup>
                );
//<ListGroupItem><b>OUT:</b> {this.props.im.out}</ListGroupItem>
//                   <ListGroupItem><b>IN:</b> {this.props.im.in}</ListGroupItem>
//                    <ListGroupItem><b>GT:</b> {this.props.im.gt}</ListGroupItem>
    }
};

class ImageCollection extends Component{
    constructor(props){
        super(props);
        this.per_page = 12;
        this.state = {'cur_pos' : this.per_page*(10 - 1), 'cur_page' : 10};
        this.num_page = Math.floor(props.images.length / this.per_page) + (props.images.length % this.per_page == 0 ? 0 : 1);
    };

    update_pos(i){
	if(i < 1) return false;
	
        const new_pos = this.per_page * (i-1);
        this.setState({cur_pos : new_pos,
                        cur_page : i});
        $('html, body').animate({ scrollTop: 0 }, 'fast'); }

    render(){
        const img_list_old = this.props.images.slice(this.state.cur_pos,this.state.cur_pos+this.per_page).map((im) => {
	    //const img_col = (
            //    <Col xs={12} md={4} lg={3}>
            //    <ImageShow key={im.id} im={im}/>
            //    </Col>);
            //const clearfixLg = (im.id % 4 == 3 ? <Clearfix visibleLgBlock></Clearfix> : null);
            //const clearfixMd = (im.id % 3 == 2 ? <Clearfix visibleMdBlock></Clearfix> : null);
            //return (
            //    <div key={im.id + "_div_k"}>
            //    {img_col}
            //    {clearfixLg}
            //    {clearfixMd}
            //    </div>
            //)
            const clearfixLg = (im.id % 4 == 3 ? <Clearfix visibleLgBlock></Clearfix> : null);
            const clearfixMd = (im.id % 3 == 2 ? <Clearfix visibleMdBlock></Clearfix> : null);
            const img_col = (
                <Col xs={12} md={4} lg={3}>
		<div key = {im.id + "_div_k"}>
                <ImageShow key={im.id} im={im}/>
		</div>
                </Col>);
            return img_col;
        }) 
	const images = this.props.images.slice(this.state.cur_pos,this.state.cur_pos+this.per_page);
	let img_list = [];
	for(let i = 0; i < images.length;i++){
	    const im = images[i];
            const clearfixLg = (im.id % 4 == 3 ? <Clearfix visibleLgBlock></Clearfix> : null);
            const clearfixMd = (im.id % 3 == 2 ? <Clearfix visibleMdBlock></Clearfix> : null);
            const img_col = (
                <Col xs={12} md={4} lg={3}>
		<div key = {im.id + "_div_k"}>
                <ImageShow key={im.id} im={im}/>
		</div>
                </Col>);
	    img_list.push(img_col);
	    if(im.id % 4 == 3){
		    img_list.push(<Clearfix visibleLgBlock></Clearfix>)
	    }
	    if(im.id % 3 == 2){
		    img_list.push(<Clearfix visibleMdBlock></Clearfix>)
	    }
	}
	let active = this.state.cur_page;
	let pg_items = [];
	pg_items.push((<Pagination.First onClick={() => this.update_pos(1)}/>));
	pg_items.push((<Pagination.Prev onClick={() => this.update_pos(active-1)}/>));
	const width = 10;
	let m = active;
	let s = m-width/2;
	let e = m+width/2;
	if(s < 1){
		e += 1 - s;
		s = 1;
	}
	if(e > this.num_page){
		s -= e - this.num_page;
		e = this.num_page;
	}
	if(s < 1){ s = 1; }
	for(let i = s;i <= e;i++){
		pg_items.push(
			<Pagination.Item key={i} active={i === active} onClick={() => this.update_pos(i)}>{i}</Pagination.Item>
		);
	}
	pg_items.push((<Pagination.Next onClick={()=>this.update_pos(Math.min(active+1, this.num_page))}/>));
	pg_items.push((<Pagination.Last onClick={()=>this.update_pos(this.num_page)}/>));
        
        return (<div>
                <Pagination bsSize="large">{pg_items}</Pagination>
                <Grid>
                <Row>
                {img_list}
                </Row>
                </Grid>
                <Pagination bsSize="large" items={this.num_page} activepage={this.state.cur_page} onSelect={(v) => this.update_pos(v)}/>
                </div>
               );
    }
};

class ChooseFile extends Component{
    constructor(props){
        super(props);
        this.state = {data_list : null};
    }

    componentWillMount(){
        $.getJSON("./data_manifest.json", (json) => this.buildList(json));
    }


    buildList(json){
        this.setState({data_list : json});
    }

    renderList(){
        if(this.state.data_list == null){
            return (<h2>Loading...</h2>);
        }

        const lst = this.state.data_list.map((row) =>
                (
                    <ListGroupItem key={row.fname} onClick={() => this.props.chooseFile(row.fname)} header={"File " + row.fname + ":"}>
                    {row.desc}
                    </ListGroupItem>
                    ));

        return (<Panel header="Select file to show">
                <ListGroup>
                {lst}
                </ListGroup>
                </Panel>
                );

    }

    render(){

        return (<div>
                {this.renderList()}
                </div>);
                
    }
}

class App extends Component {
  constructor(props){
    super(props);
    this.state = {image_data : null, loaded_data : false};
  }

  chooseFile(cur, fname){
      console.log(this)
      $.getJSON(fname, (json) => this.prepImageData(json))
  }

  componentWillMount(){
    //$.getJSON("./test_out_29_06_17.json", (json) => this.prepImageData(json));
    //$.getJSON("./test_full_path_nosamp_03_07_17.json", (json) => this.prepImageData(json));
  }

  prepImageData(image_data){
    const mscoco_url = "http://users.cecs.anu.edu.au/~u4534172/mscoco_images/";
    for(var i=0;i<image_data.length;i++){
        image_data[i].fname = mscoco_url+image_data[i].fname;
        image_data[i].id = i;
    }
    this.setState({image_data:image_data, loaded_data:true});
  }

  goBack(){
      this.setState({loaded_data:false});
  }

  render() {
    const _this = this;
    function getDisp(){
        if(_this.state.loaded_data)
            return (<div>
                    <Button onClick={() => _this.goBack()} >Back to File List</Button><br/>
                    <ImageCollection images={_this.state.image_data}/>
                    <Button onClick={() => _this.goBack()} >Back to File List</Button>
                    </div>);
        else
            return (<ChooseFile chooseFile={(fname) => _this.chooseFile(_this, fname)}/>);
    }
    const disp = getDisp(this)
    return (
      <div className="App">
        <div className="App-header">
          <h2>SemStyle: Example Viewer</h2>
        </div>
        {disp}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js